import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { TreeNode } from 'primeng/api';
import { Observable } from 'rxjs';
import { filtroDashboard, kpi, PedidoDetalheDashboard } from './models/dashboard';


@Injectable({
  providedIn: 'root'
})

export class DashboardService {

  private environmentUrl: string = "";

  constructor(private httpClient: HttpClient) { this.environmentUrl = environment.ApiCore; }

  getFiles() {
    return this.httpClient.get<any>('assets/demo/data/files.json')
      .toPromise()
      .then(res => res.data as TreeNode[]);
  }

  getGraficoFornecedor(idEvento: string, idVisao: number, filtro: filtroDashboard[]): Observable<any[]> {
    let url = this.environmentUrl + "/dashboard/eventoFornecedor/" + idEvento + "/" + idVisao;
    return this.httpClient.post<any[]>(url, filtro);
  }

  getGraficoVendedor(idEvento: string, idVisao: number, filtro: filtroDashboard[]): Observable<any[]> {
    let url = this.environmentUrl + "/dashboard/eventoVendedor/" + idEvento + "/" + idVisao;
    return this.httpClient.post<any[]>(url, filtro);
  }

  getGraficoCidade(idEvento: string, idVisao: number, filtro: filtroDashboard[]): Observable<any[]> {
    let url = this.environmentUrl + "/dashboard/eventoCidade/" + idEvento + "/" + idVisao;
    return this.httpClient.post<any[]>(url, filtro);
  }

  getGraficoCliente(idEvento: string, idVisao: number, filtro: filtroDashboard[]): Observable<any[]> {
    let url = this.environmentUrl + "/dashboard/eventoCliente/" + idEvento + "/" + idVisao;
    return this.httpClient.post<any[]>(url, filtro);
  }

  getGraficoProduto(idEvento: string, idVisao: number, filtro: filtroDashboard[]): Observable<any[]> {
    let url = this.environmentUrl + "/dashboard/eventoProduto/" + idEvento + "/" + idVisao;
    return this.httpClient.post<any[]>(url, filtro);
  }

  
  getKpi(idEvento: string): Observable<kpi> {
    let url = this.environmentUrl + "/dashboard/kpi/" + idEvento;
    return this.httpClient.get<kpi>(url);
  }

  getLine(idEvento: string): Observable<any[]> {
    let url = this.environmentUrl + "/dashboard/Line/" + idEvento;
    return this.httpClient.get<any[]>(url);
  }

  getListaPedidoDetalhe(idEvento: string): Observable<PedidoDetalheDashboard[]> {
    let url = this.environmentUrl + "/dashboard/ListaDetalhePedido/" + idEvento;
    return this.httpClient.get<PedidoDetalheDashboard[]>(url);
  }

}
